import { FacebookPixelService } from './facebook-pixel.service'

export const fbp = new FacebookPixelService()
